/**
 *  @class
 *  @function ProductsBadgeSidebar
 */
if (!customElements.get('products-badge-sidebar')) {
  class ProductsBadgeSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.products-badge-button');
      this.content = this.querySelectorAll('.products-badge-content-inner');
      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseover', (event) => {
          this.onHover(event, button, i);
        });
      });
      this.images = this.querySelectorAll('img');

      window.addEventListener('load', (event) => {
        this.images.forEach(function (image) {
          if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
            lazySizes.loader.unveil(image);
          }
        });
      });
    }

    onHover(event, button, i) {
      this.content.forEach((content, index) => {
        content.classList.remove('active');
        if (i == index) {
          content.classList.add('active');
        }
      });
      this.buttons.forEach((this_button, index) => {
        this_button.classList.remove('active');
      });
      button.classList.add('active');
    }
  }
  customElements.define('products-badge-sidebar', ProductsBadgeSidebar);
}
